import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom"
import { Header } from "@/components/layout/Header"
import { Footer } from "@/components/layout/Footer"
import { ScrollToTop } from "@/components/ScrollToTop"
import { HomePage } from "@/pages/HomePage"
import { AboutPage } from "@/pages/AboutPage"
import { ProgramsPage } from "@/pages/ProgramsPage"
import { InternationalPage } from "@/pages/InternationalPage"
import { ContactPage } from "@/pages/ContactPage"
import { CompetitionRegistrationPage } from "@/pages/CompetitionRegistrationPage"
import { EventsPage } from "@/pages/EventsPage"
import { Toaster } from "@/components/ui/sonner"
import { useIntroSplash } from "@/components/IntroSplash"
import { WhatsAppButton } from "@/components/WhatsAppButton"

function AppContent() {
  const location = useLocation()
  const isHomePage = location.pathname === "/"
  const { showSplash, SplashComponent } = useIntroSplash()

  // Only show splash on homepage
  const shouldShowSplash = isHomePage && showSplash

  return (
    <>
      {/* Page content renders underneath, splash overlays on top */}
      <div className="min-h-screen">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/international" element={<InternationalPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/competition-register" element={<CompetitionRegistrationPage />} />
            <Route path="/events" element={<EventsPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </div>
      {/* Splash overlays on top and fades away to reveal content */}
      {shouldShowSplash && SplashComponent}
    </>
  )
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppContent />
    </BrowserRouter>
  )
}

export default App